<script>
    export let name = "Undefined stat";
    export let value;
    export let tick = 0;
    let previous = value;
    let change = 0;
    $: {
        tick; // re-run every turn even if value itself didn't change,
              // so a stale delta badge from a prior turn gets cleared
        change = value - previous;
        previous = value;
    }
</script>

<span>
    {name}: {value.toFixed(2)}
    {#if change < -0.001}
        <sl-badge type="danger" pill>{(change * 100).toFixed(0)}</sl-badge>
    {:else if change > 0.001}
        <sl-badge type="success" pill>+{(change * 100).toFixed(0)}</sl-badge>
    {/if}
</span>
<progress value={value}></progress>


<style>
	progress {
		display: block;
		width: 100%;
	}
    progress::-webkit-progress-value {
        transition: width 2.5s ease-in-out;
    }
</style>